<header class="first-time-user-experience__header">
    <h1 class="first-time-user-experience__title">
        @if (educationalLevels$ && !displayStepInterval) {
            <strong [innerHTML]="'first_time_user_experience.teaching_grade' | translate">
            </strong>
        } @else if (displayStepInterval) {
            <strong [innerHTML]="'first_time_user_experience.starting_grade' | translate">
            </strong>
        }
    </h1>
    <div class="first-time-user-experience__decoration"
         aria-hidden="true">
    </div>
</header>
<div class="first-time-user-experience__content">
    @if (educationalLevels$ && !displayStepInterval) {
        <mat-chip-listbox class="first-time-user-experience__chip-list"
                          multiple>
            @defer (when educationalLevels$ | async; prefetch on idle) {
                @for (educationalLevel of educationalLevels$ | async; track educationalLevel.id) {
                    <mat-chip-option class="first-time-user-experience__chip"
                                     (selectionChange)="selectEducationalLevel(educationalLevel)">
                        <span>{{ educationalLevel.get('label') }}</span>
                    </mat-chip-option>
                }
            } @placeholder {
                @for (item of [].constructor(5); track $index) { <!-- Boucle de 4 itérations -->
                <mat-chip-option class="first-time-user-experience__chip first-time-user-experience__chip--placeholder"
                                 disabled>
                </mat-chip-option>
                }
            }
        </mat-chip-listbox>
        <button class="first-time-user-experience__next-button"
                [disabled]="!selectedEducationalLevels.length"
                (click)="onNext()">
            <span>{{'generic.next' | translate}}</span>
            <mat-icon svgIcon="first-time-user-experience__next"></mat-icon>
        </button>
    } @else if (displayStepInterval) {
        <mat-chip-listbox class="first-time-user-experience__chip-list">
            @for (educationalLevel of selectedEducationalLevels  | filterEducationalLevelsPipe:selectedEducationalLevels; track educationalLevel.id) {
                <mat-chip-option class="first-time-user-experience__chip"
                                 (selectionChange)="selectEducationalLevelStarter(educationalLevel)">
                    <span>{{ educationalLevel.get('label') }}</span>
                </mat-chip-option>
            }
        </mat-chip-listbox>
        <button class="first-time-user-experience__next-button"
                [disabled]="!educationalLevelStarter"
                (click)="onNext()">
            <span>{{'generic.next' | translate}}</span>
            <mat-icon svgIcon="first-time-user-experience__next"></mat-icon>
        </button>
    }
</div>
